import type { InitialTableState } from '@tanstack/react-table'

import { DataTable } from '@/components/ui/table/data-table.tsx'

import type { LicensesTableType } from '../../types'
import { licensesTableColumns } from './columns'

interface Props {
  licenseQuantity: number
  licensesUsed: number
  licensesTable: LicensesTableType[]
}

export const LicensesTable = (props: Props) => {
  const { licenseQuantity, licensesUsed, licensesTable } = props
  const initialState: InitialTableState = {}

  return (
    <>
      <p className="mt-[-15px] pb-4 text-sm text-title">
        You have used {licensesUsed} out of {licenseQuantity} licenses
      </p>
      <DataTable
        enableSorting
        enableSortingRemoval
        enablePagination
        data={licensesTable}
        columns={licensesTableColumns}
        initialState={initialState}
        sortingState={[{ id: 'planDisplayName', desc: false }]}
      />
    </>
  )
}
